/* eslint-disable no-console */
import Vue from "vue";
import Vuex from "vuex";
import cloneDeep from "lodash/cloneDeep";
import createPersistedState from "vuex-persistedstate";
import globalStore from "@/modules/global/store/globalStore.js";
import loginStore from "@/modules/auth/store/loginStore.js";
import engagementStore from "@/modules/global/store/engagementsStore.js";
import newEngagementsStore from "@/modules/global/store/newEngagementsStore.js";
import adminStore from "@/modules/admin-management/store/adminStore.js";
import couponStore from "@/modules/global/store/couponStore.js";
// import VuexPersistence from "vuex-persist";
Vue.use(Vuex);

const defaultState = {
  screenLoading: false
};

const dataState = createPersistedState({
  paths: ["loginStore"]
});

export default new Vuex.Store({
  modules: {
    loginStore,
    globalStore,
    adminStore,
    engagementStore,
    newEngagementsStore,
    couponStore
  },
  state: cloneDeep(defaultState),
  getters: {
    screenLoading: state => {
      return state.screenLoading;
    }
  },
  mutations: {
    SET_SCREEN_LOADING(state, val) {
      state.screenLoading = val;
    }
  },
  actions: {
    async SET_SCREEN_LOADING({ commit }, payload) {
      commit("SET_SCREEN_LOADING", payload);
    },
    logout({ dispatch, commit, rootState }) {
      dispatch("globalStore/resetState");
      dispatch("loginStore/resetState");
    }
  },
  plugins: [dataState]
});
